// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","logo":"Logo_logo__1aodv","image":"Logo_image__2EVHB","text":"Logo_text__QTQJa"};